module.exports = __webpack_public_path__ + "media/images/realizacje/real15-b6749640b542aa124174dd39283c777b.png";